import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

export default function AboutPage() {
  const { locale, t, prefix } = useLanguage();

  const boardMembers = locale === 'zh' ? [
    { name: 'Sarah Yang', role: '会长', duties: ['公共关系 (PR)', '筹款/活动策划', '监管整体运营'] },
    { name: 'Elena Pu', role: '副会长', duties: ['社区服务和学生俱乐部', '公共关系 (PR)', '活动/事件策划', '筹款'] },
    { name: 'Jenny Wei', role: '秘书长', duties: ['会员注册', '文件保管', '会议议程和纪要', 'Dropbox维护'] },
    { name: 'Annie Li', role: '财务', duties: ['账目管理', '筹款', '税务申报'] },
  ] : [
    { name: 'Sarah Yang', role: 'President', duties: ['Public Relations (PR)', 'Fund Raising/Event Planning', 'Oversight overall operations'] },
    { name: 'Elena Pu', role: 'Vice President', duties: ['Community services and student club', 'Public Relations (PR)', 'Activity/Event Planning', 'Fund Raising'] },
    { name: 'Jenny Wei', role: 'Secretary', duties: ['Member registration', 'Documents keeping', 'Meeting agenda and minutes', 'Dropbox Maintenance'] },
    { name: 'Annie Li', role: 'Treasurer', duties: ['Book Keeping', 'Fund Raising', 'Tax filing'] },
  ];

  const studentClubs = locale === 'zh' ? [
    { name: '新移民小助手', desc: '由高中、初中和小学学生组成，帮助新来的华人移民学生适应橙县学校生活。成员通过电话和网络提供同伴支持，帮助新生适应课业、建立友谊。' },
    { name: 'Sincerely Hope', desc: '服务型俱乐部，致力于培养青年的社区参与意识。活动包括公园清洁、图书馆图书修复、为低收入儿童准备礼物等。' },
    { name: 'Opportunity Sportz', desc: '为低收入社区的四五年级学生提供更多、更丰富的体育机会。成员担任教练和导师，帮助获取体育设备。' },
    { name: '表演艺术俱乐部', desc: '专注于艺术的组织，致力于扩大学生参与艺术活动和文化项目的机会。' },
  ] : [
    { name: 'New Student Assistant Club', desc: 'Comprising high school, middle school, and elementary students working to help newly arrived Chinese immigrant students acclimate to Orange County schools through peer support.' },
    { name: 'Sincerely Hope', desc: 'Service-oriented club fostering community engagement among youth. Activities include park cleanups, library book repairs, and gift preparation for low-income children.' },
    { name: 'Opportunity Sportz', desc: 'Providing sports opportunities to 4th and 5th graders in low-income communities. Members serve as coaches and mentors while building meaningful friendships.' },
    { name: 'Performing Arts Club', desc: 'Arts-focused organization dedicated to expanding student participation in artistic activities and cultural programs.' },
  ];

  const missionEn = {
    title: 'Our Mission',
    text1: 'Our mission is to promote Chinese culture, support and serve the local communities, and build bridges among Chinese Americans and all other ethnic groups to strengthen the sense of community for our future generations.',
    text2: 'Through education, community involvement, and services for immigrants and local businesses, we help Chinese Americans integrate into the global community while developing future leaders.',
    parentTitle: 'Chinese Parent Federation',
    parentText: 'CAAOC operates the Chinese Parent Federation (橙县华人家长联合会), a voluntary membership body focused on creating communication channels between schools, students, and families, advocating for student interests while disseminating school policies to the Chinese community.',
  };

  const missionZh = {
    title: '我们的使命',
    text1: '橙县华人协会是一个无党派、无宗派的非营利社区团体。我们的使命是推广中华文化，支持和服务本地社区，在华裔美国人与所有族裔之间搭建桥梁，为下一代增强社区意识。',
    text2: '主要目标包括加强和谐、减少文化差距、促进商业交流，帮助新老华人居民了解美国文化、政府、学校和公民体系。',
    parentTitle: '橙县华人家长联合会',
    parentText: '华人家长联合会是一个自愿会员组织，致力于在学校、学生和家庭之间建立沟通渠道，为学生利益发声，同时向华人社区传播学校政策信息。',
  };

  const mission = locale === 'zh' ? missionZh : missionEn;

  const storyEn = {
    title: 'Our Story',
    text: 'The Chinese-American Association of Orange County (CAAOC) was formally registered as a nonprofit organization, founded in 2012. Its purpose is to strengthen communication and mutual assistance among Chinese parents, enhance the image of the Chinese community\'s participation in local affairs and school districts, and provide a platform for children to participate in community activities. Over the past years, CAAOC has organized educational seminars, cultural events, summer camp fairs, school selection forums, and family education sharing sessions, leaving a trail of extraordinary footprints in our community.',
    founding: 'In Southern California\'s Orange County, there is a group of parents in their thirties and fifties, from different professions — working fathers, stay-at-home mothers — who share a common identity: volunteers of the Chinese Parent Association of Orange County.',
  };

  const storyZh = {
    title: '我们的故事',
    text: '橙县华人协会是一个正式注册的非营利民间组织，成立于2012年，其目的是为了增强家长之间的交流与互助，以华人群体的形象参与社区与学区的建设，为孩子们参加社会活动提供平台。在过去的几年以来，华人家长会在家长们的热心支持和积极参与下，与橙县各大华人社团携手，主办及协办了一系列的活动，留下一串平凡但坚实的足迹。',
    founding: '在南加州的橙县地区，有着这样一群中年人的身影，他们有的三十出头，有的五十开外，他们从事着不同职业，既有工作的爸爸，也有不少全职妈妈。但他们又有着一个共同的身份，那就是：橙县华人家长会的义工。',
  };

  const story = locale === 'zh' ? storyZh : storyEn;

  const activities = locale === 'zh' ? [
    '组织了各种教育讲座，例如"如何培养高情商的孩子"的座谈会',
    '组织了"网络安全教育"讲座，向家长们介绍如何监督指导孩子避免网络中潜在的风险',
    '组织了"新移民如何适应美国教育体系"的讲座',
    '组织了夏令营及暑期课程介绍展览会',
    '组织了"如何选择学校"座谈会',
    '组织了一系列家庭教育经验分享会',
    '主办《盛宴》春晚，在Irvine Barclay Theatre演出',
  ] : [
    'Educational seminars on raising emotionally intelligent children',
    'Internet safety education workshops for parents',
    'Seminars on adapting to the American education system for new immigrants',
    'Summer camp and program fairs with 10+ educational organizations',
    'School selection forums with parents and students from public and private schools',
    'Family education experience sharing sessions',
    'Annual Festive Feast (盛宴) Spring Gala at Irvine Barclay Theatre',
  ];

  return (
    <div>
      {/* Hero */}
      <section
        style={{
          background: 'linear-gradient(135deg, #E65100 0%, #BF360C 100%)',
          color: '#fff',
          padding: '100px 0 60px',
        }}
      >
        <div className="container" style={{ textAlign: 'center' }}>
          <h1 style={{ fontSize: '2.8rem', fontWeight: 900, marginBottom: 12 }}>
            {locale === 'zh' ? '关于我们' : 'About CAAOC'}
          </h1>
          <p style={{ fontSize: '1.15rem', opacity: 0.9, maxWidth: 700, margin: '0 auto' }}>
            {locale === 'zh'
              ? '橙县华人协会 — 建设社区，传承文化，服务华人家庭'
              : 'Chinese-American Association of Orange County — Building community, preserving culture, serving families'}
          </p>
        </div>
      </section>

      {/* Mission */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--white)' }}>
        <div className="container" style={{ maxWidth: 900, textAlign: 'center' }}>
          <h2 className="section-title" style={{ marginBottom: 24 }}>{mission.title}</h2>
          <p style={{ fontSize: '1.2rem', color: 'var(--gray-600)', lineHeight: 1.8, marginBottom: 16 }}>
            {mission.text1}
          </p>
          <p style={{ fontSize: '1.1rem', color: 'var(--gray-500)', lineHeight: 1.7, marginBottom: 24 }}>
            {mission.text2}
          </p>
          <div style={{ background: 'var(--red-bg)', borderRadius: 'var(--radius-md)', padding: '24px 32px', textAlign: 'left' }}>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--red-primary)', marginBottom: 8 }}>{mission.parentTitle}</h3>
            <p style={{ fontSize: '0.95rem', color: 'var(--gray-600)', lineHeight: 1.7 }}>{mission.parentText}</p>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--gray-100)' }}>
        <div className="container" style={{ maxWidth: 900 }}>
          <h2 className="section-title" style={{ textAlign: 'center', marginBottom: 32 }}>{story.title}</h2>
          <div style={{ background: 'var(--white)', borderRadius: 'var(--radius-md)', padding: '32px', boxShadow: 'var(--shadow-sm)' }}>
            <p style={{ fontSize: '1.05rem', color: 'var(--gray-600)', lineHeight: 1.8, marginBottom: 20, fontStyle: 'italic', borderLeft: '4px solid var(--red-primary)', paddingLeft: 20 }}>
              {story.founding}
            </p>
            <p style={{ fontSize: '1rem', color: 'var(--gray-600)', lineHeight: 1.8, marginBottom: 24 }}>
              {story.text}
            </p>
            <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--gray-800)', marginBottom: 12 }}>
              {locale === 'zh' ? '主要活动和成就' : 'Key Activities & Achievements'}
            </h3>
            <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: 8 }}>
              {activities.map((a, i) => (
                <li key={i} style={{ fontSize: '0.95rem', color: 'var(--gray-600)', lineHeight: 1.6, paddingLeft: 20, position: 'relative' }}>
                  <span style={{ position: 'absolute', left: 0, color: 'var(--red-primary)' }}>&#10003;</span>
                  {a}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Board members */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--white)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <h2 className="section-title">{locale === 'zh' ? '我们的团队' : 'Our Team'}</h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>
              {locale === 'zh' ? '协会领导团队' : 'Association Leadership Team'}
            </p>
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
              gap: 24,
              maxWidth: 900,
              margin: '0 auto',
            }}
          >
            {boardMembers.map((member) => (
              <div key={member.name} className="card" style={{ padding: 24 }}>
                <div style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 16 }}>
                  <div
                    style={{
                      width: 56,
                      height: 56,
                      borderRadius: '50%',
                      background: 'var(--red-bg)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.4rem',
                      flexShrink: 0,
                      color: 'var(--red-primary)',
                      fontWeight: 800,
                    }}
                  >
                    {member.name.charAt(0)}
                  </div>
                  <div>
                    <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--gray-900)', marginBottom: 2 }}>
                      {member.name}
                    </h3>
                    <div style={{ fontSize: '0.88rem', fontWeight: 600, color: 'var(--red-primary)' }}>
                      {member.role}
                    </div>
                  </div>
                </div>
                <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: 4 }}>
                  {member.duties.map((d, i) => (
                    <li key={i} style={{ fontSize: '0.85rem', color: 'var(--gray-600)', paddingLeft: 16, position: 'relative' }}>
                      <span style={{ position: 'absolute', left: 0, color: 'var(--gray-400)' }}>&#8226;</span>
                      {d}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Student Clubs */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--gray-100)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <h2 className="section-title">{locale === 'zh' ? '学生社团' : 'Student Clubs'}</h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>
              {locale === 'zh' ? '由CAAOC组织的青年学生俱乐部' : 'Youth organizations organized by CAAOC'}
            </p>
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
              gap: 24,
            }}
          >
            {studentClubs.map((club) => (
              <div key={club.name} className="card" style={{ padding: 24 }}>
                <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--red-primary)', marginBottom: 8 }}>
                  {club.name}
                </h3>
                <p style={{ fontSize: '0.9rem', color: 'var(--gray-600)', lineHeight: 1.6 }}>
                  {club.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Festive Feast */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--white)' }}>
        <div className="container" style={{ maxWidth: 900, textAlign: 'center' }}>
          <h2 className="section-title" style={{ marginBottom: 16 }}>
            {locale === 'zh' ? '《盛宴》春晚' : 'Festive Feast Spring Gala'}
          </h2>
          <p style={{ fontSize: '1.05rem', color: 'var(--gray-600)', lineHeight: 1.7, marginBottom: 24 }}>
            {locale === 'zh'
              ? 'CAAOC每年举办《盛宴》春晚，在Irvine Barclay Theatre隆重上演。这是一场艺术的盛大绽放，是经典与创新的奇妙交融，是中华文化之美与南加州热情的精彩碰撞。春晚将嘉年华、文艺演出和社区欢聚融为一体。'
              : 'CAAOC hosts the annual Festive Feast (盛宴) Spring Gala at the Irvine Barclay Theatre. It is a grand artistic celebration blending classical and innovative elements — a fusion of Chinese cultural beauty and Southern California warmth. The gala combines carnival festivities, performing arts, and community gathering.'}
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 24 }}>
            {[
              { year: '2026', date: locale === 'zh' ? '2026年1月30日' : 'January 30, 2026' },
              { year: '2025', date: locale === 'zh' ? '2025年1月12日' : 'January 12, 2025' },
              { year: '2024', date: locale === 'zh' ? '2024年2月3日' : 'February 3, 2024' },
            ].map((g) => (
              <div key={g.year} style={{ background: 'var(--red-bg)', borderRadius: 'var(--radius-md)', padding: '20px 16px' }}>
                <div style={{ fontSize: '1.8rem', fontWeight: 900, color: 'var(--red-primary)', lineHeight: 1 }}>{g.year}</div>
                <div style={{ fontSize: '0.85rem', color: 'var(--gray-600)', marginTop: 4 }}>{g.date}</div>
              </div>
            ))}
          </div>
          <p style={{ fontSize: '0.95rem', color: 'var(--gray-500)', lineHeight: 1.6 }}>
            {locale === 'zh'
              ? '演出地点：Irvine Barclay Theatre, 4242 Campus Dr, Irvine, CA 92612 | 时间：5:30-7:00pm 嘉年华 / 7:00-9:30pm 演出'
              : 'Venue: Irvine Barclay Theatre, 4242 Campus Dr, Irvine, CA 92612 | Schedule: 5:30-7:00pm Carnival / 7:00-9:30pm Performance'}
          </p>
        </div>
      </section>

      {/* Stats */}
      <section style={{ padding: '60px 0', background: 'var(--red-primary)', color: '#fff' }}>
        <div className="container">
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: 32,
              textAlign: 'center',
            }}
          >
            {[
              { number: '2012', label: locale === 'zh' ? '成立年份' : 'Founded' },
              { number: '4', label: locale === 'zh' ? '学生社团' : 'Student Clubs' },
              { number: '3', label: locale === 'zh' ? '年度春晚' : 'Annual Galas' },
              { number: '100+', label: locale === 'zh' ? '义工志愿者' : 'Volunteers' },
            ].map((stat) => (
              <div key={stat.label}>
                <div style={{ fontSize: '2.5rem', fontWeight: 900, lineHeight: 1 }}>{stat.number}</div>
                <div style={{ fontSize: '0.95rem', opacity: 0.85, marginTop: 4, fontWeight: 500 }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--white)', textAlign: 'center' }}>
        <div className="container" style={{ maxWidth: 600 }}>
          <h2 className="section-title" style={{ marginBottom: 16 }}>
            {locale === 'zh' ? '加入我们的社区' : 'Join Our Community'}
          </h2>
          <p style={{ fontSize: '1.05rem', color: 'var(--gray-600)', lineHeight: 1.7, marginBottom: 32 }}>
            {locale === 'zh'
              ? '无论您是新移民还是长期居民，CAAOC欢迎所有有兴趣参与华人社区建设的朋友加入。'
              : 'Whether you are a new immigrant or long-time resident, CAAOC welcomes everyone interested in building the Chinese-American community.'}
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to={prefix + '/events'} className="btn btn-primary" style={{ padding: '14px 32px' }}>
              {locale === 'zh' ? '浏览活动' : 'Browse Events'}
            </Link>
            <Link to={prefix + '/contact'} className="btn btn-outline" style={{ padding: '14px 32px' }}>
              {locale === 'zh' ? '联系我们' : 'Contact Us'}
            </Link>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          .container > div[style*="grid-template-columns: repeat(4"] {
            grid-template-columns: repeat(2, 1fr) !important;
          }
          .container > div[style*="grid-template-columns: repeat(3"] {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
}
